import "../../Styles/ContactUs.css";
import { Helmet } from "react-helmet";
import HeaderSection from "../../Components/HeaderSection/HeaderSection";
import PageDescription from "../../Components/PageDescription/PageDescription";
import "./Partners.css";
import Text from "../../Components/Text/Text";

export default function Partners() {
  return (
    <>
      <div className="CareerPage">
        <Helmet>
          <title>Partners</title>
        </Helmet>
        <HeaderSection
          BannerText="Our Partners"
          Src="/Images/PartnersBanner.png"
          text="Home <span>/</span>"
          text1="Partners"
          RouteLink="/"
          RouteLink1="/career"
          Color1="#6C6C6C"
          Color2="black"
        />
        <PageDescription
          text="Stronger Together"
          text1="At DynaSys, we believe in the power of collaboration. Our valued partners extend our reach and enhance our solutions. Together, we deliver comprehensive and innovative technologies. "
        />
        <div className="TechnologyPartners">
          <div className="TechnologyHead">
            <Text text={"Technology <br> Partners"} Margin={"0px 0px 35px 0px"} FontSize="3rem" FontWeight="600" />
          </div>
          <div className="TechnologyPartnersWrapper">
            <div className="Milesight">
              <img className="DektopMilesight" src="/Images/milesight2.png" alt="" />
              <img className="MobileMilesight"   src="/Images/milesight.png" alt="" />
              <Text Margin={"35px 0px"} text={"Milesight is a high-tech company specializing in the Internet of Things (IoT). They are known for their robust portfolio of IoT devices, including LoRaWAN sensors, gateways, and controllers, catering to diverse applications."}  />
            </div>
            <div className="Quantica">
              <img src="/Images/qunantica.png" alt="" />
              <Text Margin={"35px 0px"} text={"Quantica is a unified business platform for IoT, marketing, analytics, communications, and consulting."}  />
            </div>
          </div>
        </div>
        <div className="EmbeddedPartner">
          <div className="TechnologyHead">
            <Text text={"Embedded  <br> Partners"} Margin={"0px 0px 35px 0px"} FontSize="3rem" FontWeight="600" />
          </div>
          <div className="TechnologyPartnersWrapper">
            <div className="Milesight">
              <img src="/Images/JazzLogo.png" alt="" />
              <Text Margin={"35px 0px"} text={"Jazz, a subsidiary of VEON, stands at the forefront of Pakistan's digital revolution. With over 100 million subscribers of its various products and services, it is actively expanding its digital infrastructure, including mobile broadband, IoT, fintech solutions, cloud and cybersecurity services, and various digital lifestyle offerings."}  />
            </div>
          </div>
        </div>
      </div>
      <div className="borderSec">
        <div className="border"></div>
      </div>
    </>
  );
}
